import { SUBJECT_DISPLAY, type SubjectEnum } from './notification-constants';

/**
 * Map server display string → enum constant. Mirrors Flutter
 * `notification_model.dart:69-74` `subjectValues.map`. Returns null if
 * the server ships an unrecognized subject (defensive — Flutter would
 * return null too, the map lookup returns null on miss).
 */
export function fromSubjectDisplay(display: string): SubjectEnum | null {
  for (const key of Object.keys(SUBJECT_DISPLAY) as SubjectEnum[]) {
    if (SUBJECT_DISPLAY[key] === display) return key;
  }
  return null;
}

/** Reverse — enum → display string. Useful for tests + future UI labels. */
export function toSubjectDisplay(subject: SubjectEnum): string {
  return SUBJECT_DISPLAY[subject];
}
